import { render } from "./slide-presentation.vue?vue&type=template&id=d3deb2ac&scoped=true"
import script from "./slide-presentation.vue?vue&type=script&lang=js"
export * from "./slide-presentation.vue?vue&type=script&lang=js"

import "./slide-presentation.vue?vue&type=style&index=0&id=d3deb2ac&lang=scss&scoped=true"
import "./slide-presentation.vue?vue&type=style&index=1&id=d3deb2ac&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3deb2ac"]])

export default __exports__